import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Header from 'components/Header/Header';
import ProductSelector from 'components/ProductSelector/ProductSelector';
import JobSize from 'components/JobSize/JobSize';
import TilesSizes from 'components/TilesSizes/TilesSizes';
import GroutJointSize from 'components/GroutJointSize/GroutJointSize';
import Calculation from 'components/Calculation/Calculation';
import Loader from 'components/Loader/Loader';
import styles from './styles';
import { css } from 'aphrodite';
import { ResetCss } from 'library';

let jsonData;
let groutData;

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: null,
            isImperialSystem: null,
            isError: false,
            selectedProduct: false,
            isProductSelectorError: false,
            area: null,
            isAreaError: false,
            tilesDimensions: null,
            isTilesDimensionsError: false,
            isTilesDimensionsFloorPartError: false,
            jointDimensions: null,
            isJointDimensionsError: false,
            isReady: false,
            showResult: false,
        }

        this.myRefs = [];

        this.pushPageInfoDataLayer();
    }

    pushPageInfoDataLayer() {
        const { dataLayer, country, locale } = this.props;

        function getHostName(url) {
            var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
            if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
            return match[2];
            }
            else {
                return null;
            }
        }
        const dataLayerContext = getHostName(window.location.href);

        if (dataLayer !== null) {
            dataLayer.push({
                'event' : 'pageInfo_grout',
                'pageType' : 'groutCalculator',
                'bu': 'Construction',
                'context' : dataLayerContext,
                'country' : country,
                'language': locale
            });

            // console.log(dataLayer);
        }
    }

    componentDidMount() {
        //call graphQL with locale as parameter
        const { locale, context, groutKey } = this.props;
        var domainName;

        if (context === 'local') {
            domainName = 'http://localhost:9112';
        }
        else if (context === 'int' || context === 'qual') {
            domainName = 'https://grout-calculator.bostik.'+ context +'.eurelis.info';
        } else {
            domainName = 'https://back.grout-calculator.bostik';
        }
        const graphqlRequest = domainName +'/graphql?query={%20nodeQuery(filter:%20{conditions:%20[{field:%20%22langcode%22,%20value:%22'+ locale +'%22},%20{field:%20%22type%22,%20value:%20%22grout_calculator_page%22}]})%20{%20entities%20{%20entityLabel%20...%20on%20NodeGroutCalculatorPage%20{%20body%20{%20value%20}%20fieldGroutSlug%20fieldMetricLabel%20fieldImperiaLabel%20fieldDisplayUnitSwitch%20fieldUnitSystem%20fieldImage%20{%20entity%20{%20...mediaImage%20}%20}%20fieldProductsZoneTitle%20fieldProductLinkTitle%20fieldProducts%20{%20entity%20{%20...products%20}%20}%20fieldJszTitle%20fieldJszDescription%20fieldJsWidthLabel%20fieldJsWidthFieldDescription%20fieldJsHeightFieldLabel%20fieldJsHeightFieldDesc%20fieldJsAreaFieldLabel%20fieldJsAreaFieldDesc%20fieldJsFieldImage%20{%20entity%20{%20...mediaImage%20}%20}%20fieldJobSizeImageFeetsquare%20{%20entity%20{%20...mediaImage%20}%20}%20fieldTsZoneTitle%20fieldTsZoneDescription%20fieldTsWidthFieldLabe%20fieldTsWidthFieldDesc%20fieldTsHeightFieldTit%20fieldTsHeightFieldDesc%20fieldTsFloorPartField%20fieldTsFloorPartFieldDesc%20fieldTsOperator%20fieldTsRowTitle%20fieldTsFieldImage%20{%20entity%20{%20...mediaImage%20}%20}%20fieldTileSizeFieldImageMult%20{%20entity%20{%20...mediaImage%20}%20}%20fieldTsAddAnotherButton%20fieldGjZoneTitle%20fieldGjZoneDescription%20fieldGjWidthFieldLabel%20fieldGjWidthFieldDesc%20fieldGjHeightFieldLabel%20fieldGjHeightFieldDesc%20fieldGjFieldImage%20{%20entity%20{%20...mediaImage%20}%20}%20fieldResultsZoneTitle%20fieldCalculateButtonLabel%20fieldDisclaimer%20fieldTotalAmountTitle%20fieldPackagedAmountTitle%20fieldPrintButtonLabel%20fieldDistributorButtonLabel%20fieldDistributorLink{%20uri%20}%20fieldGroutJointErrorMessage%20fieldProductErrorMessage%20fieldTileSizeLimitMessage%20fieldTilesSizesErrorMessage%20fieldJobSizeErrorMessage%20fieldFloorPartMatchError%20fieldCalculationLabelOf%20fieldCalculationOrLabel%20fieldCalculationInactiveButto%20fieldJobSizeErrorMessage%20fieldProductErrorMessage%20fieldGroutJointErrorMessage%20fieldTilesSizesErrorMessage%20}%20}%20}%20}%20fragment%20products%20on%20NodeProduct%20{%20entityId%20entityLabel%20body%20{%20value%20}%20fieldDilutionRation%20fieldImage%20{%20entity%20{%20...mediaImage%20}%20}%20fieldLink%20fieldLossRatio%20fieldPackaging%20{%20entity%20{%20...packaging%20}%20}%20fieldProductDensity%20fieldBreakdownProductName%20fieldBreakdownRatio%20}%20fragment%20mediaImage%20on%20MediaImage%20{%20fieldMediaImage%20{%20entity%20{%20url%20}%20}%20}%20fragment%20packaging%20on%20TaxonomyTermPackaging%20{%20entityId%20entityLabel%20fieldAdditionalInformations%20fieldMetricImperial%20fieldQuantity%20}';

        fetch(graphqlRequest)
            .then(response => response.json())
            .then((json) => {
                jsonData = json;

                jsonData.data.nodeQuery.entities.forEach(element => {
                    var fieldGroutSlug = element.fieldGroutSlug;

                    if (groutKey === null) {
                        groutData = jsonData.data.nodeQuery.entities[0];
                    } else {
                        if (fieldGroutSlug != null && fieldGroutSlug === groutKey) {
                            groutData = element;
                        } else {
                            groutData = jsonData.data.nodeQuery.entities[0];
                        }
                    }
                });

                this.setState({
                    data: groutData,
                    isImperialSystem: groutData.fieldUnitSystem !== 'metric'
                },()=>{
                    // console.log(this.state.data);
                    this.checkIfReady();
                });
            })
            .catch((error) => {
                console.error(error)
            });

    }

    componentDidUpdate() {
        this.checkIfReady();
    }

    checkIfReady() {
        const { selectedProduct, area, tilesDimensions, jointDimensions, isTilesDimensionsFloorPartError } = this.state;
        const isReady = (selectedProduct && area && tilesDimensions && jointDimensions && !isTilesDimensionsFloorPartError) ? true : false;
        if(isReady !== this.state.isReady) {
            this.setState({isReady},()=>{
                if(this.state.isReady) this.setState({isError: false});
            });
        }
    }

    updateSystem(system) {
        this.setState({isImperialSystem: system, showResult: false})
    }

    onProductSelected(product) {
        this.setState({
            selectedProduct: product,
            isProductSelectorError: false,
            showResult: false
        },()=>{
            this.checkIfReady();
        });
    }

    onAreaEntered(area) {
        this.setState({
            area: area,
            isAreaError: !area,
            isTilesDimensionsFloorPartError: this.checkAreaEquality(this.state.tilesDimensions, area),
            showResult: false
        },()=>{
            this.checkIfReady();
        });
    }

    onTilesDimensionsEntered(tilesDimensions) {
        const { dataLayer } = this.props;

        this.setState({
            tilesDimensions: tilesDimensions,
            isTilesDimensionsError: !tilesDimensions,
            isAreaError: !this.state.area,
            isTilesDimensionsFloorPartError: this.checkAreaEquality(tilesDimensions, this.state.area),
            showResult: false
        },()=>{
            this.checkIfReady();

            if (dataLayer !== null && this.state.isTilesDimensionsFloorPartError) {
                dataLayer.push({
                    'event' : 'eventGA',
                    'eventCategory': 'Grout calculator',
                    'eventAction': 'form incorrect',
                    'eventLabel': 'value range'
                });
                // console.log(dataLayer);
            }
        });
    }

    checkAreaEquality(tiles, area) {
        let isTilesDimensionsFloorPartError = false;
        if(tiles && tiles.length > 1 && area) {
            let total = 0;
            for(let i=0; i<tiles.length; i++) {
                total += Number(tiles[i].area);
            }
            if(total !== Number(area)) isTilesDimensionsFloorPartError = true;
        }
        return isTilesDimensionsFloorPartError;
    }

    onJointDimensionsEntered(jointDimensions) {
        this.setState({
            jointDimensions,
            isJointDimensionsError: !jointDimensions,
            showResult: false
        },()=>{
            this.checkIfReady();
        });
    }

    throwError(){
        const { dataLayer } = this.props;
        let animating = false;
        let typeError = '';

        function pushDataLayer(error) {
            if (dataLayer !== null) {
                dataLayer.push({
                    'event' : 'eventGA',
                    'eventCategory': 'Grout calculator',
                    'eventAction': 'form incorrect',
                    'eventLabel': error
                });
                // console.log(dataLayer);
            }
        }

        this.setState({
            isError: true,
            isProductSelectorError: false,
            isAreaError: false,
            isTilesDimensionsError: false,
            isJointDimensionsError: false,
        },()=>{
            if(!this.state.selectedProduct && !this.state.isProductSelectorError) {
                animating=true;
                this.setState({isProductSelectorError: true}, ()=>{
                    this.scrollToRef(this.myRefs.productSelector);
                });
            }
            if(!this.state.area && !this.state.isAreaError) {
                const wasAnimating = animating;
                if(!animating) {
                    animating = true;
                }
                this.setState({isAreaError: true}, ()=>{
                    if(!wasAnimating) {
                        this.scrollToRef(this.myRefs.area);
                    }
                });
            }
            if((!this.state.tilesDimensions && !this.state.isTilesDimensionsError) || this.state.isTilesDimensionsFloorPartError) {
                const wasAnimating = animating;
                if(!animating) {
                    animating = true;
                }
                if(!this.state.tilesDimensions && !this.state.isTilesDimensionsError) {
                    this.setState({isTilesDimensionsError: true}, ()=>{
                        if(!wasAnimating) {
                            this.scrollToRef(this.myRefs.tilesDimensions);
                        }
                    });
                } else {
                    if(!wasAnimating) {
                        this.scrollToRef(this.myRefs.tilesDimensions);
                    }
                }
            }
            if(!this.state.jointDimensions && !this.state.isJointDimensionsError) {
                this.setState({isJointDimensionsError: true}, ()=>{
                    if(!animating) {
                        this.scrollToRef(this.myRefs.jointDimensions);
                    }
                });
            }
            typeError   = 'missing required field';
            pushDataLayer(typeError);
        });
    }

    scrollToRef(ref) {
        ReactDOM.findDOMNode(ref).scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    onShowResult() {
        this.setState({showResult: true},()=>{
            this.scrollToRef(this.myRefs.result);
        });
    }

    render() {
        const { dataLayer, context, country, locale } = this.props;

        var imgUrl = '';

        if (context === 'int' || context === 'qual') {
            imgUrl = 'https://grout-calculator.bostik.'+ context +'.eurelis.info';
        } else if (context === 'local' ) {
            imgUrl = '';
        } else {
            imgUrl = 'https://back.grout-calculator.bostik';
        }

        return (
            <div id="groutCalculatorMainContainer" className={css(styles.mainContainer)}>
                <ResetCss/>
                {this.state.data ?
                    <div>
                        <Header
                            image={this.state.data.fieldImage.entity.fieldMediaImage.entity.url}
                            title={this.state.data.entityLabel}
                            description={this.state.data.body !== null ? this.state.data.body.value : null}
                            metricLabel={this.state.data.fieldMetricLabel}
                            imperialLabel={this.state.data.fieldImperiaLabel}
                            isImperialSystem={this.state.isImperialSystem}
                            unitSystemToggle={this.state.data.fieldDisplayUnitSwitch}
                            updateSystem={(system)=>this.updateSystem(system)}
                        />
                        <div ref={(ref)=>this.myRefs.printContainer = ref} className={css(styles.printContainer)}>
                            <ProductSelector
                                ref={(ref)=>this.myRefs.productSelector = ref}
                                title={this.state.data.fieldProductsZoneTitle}
                                linkTitle={this.state.data.fieldProductLinkTitle}
                                products={this.state.data.fieldProducts}
                                onProductSelected={(product)=>this.onProductSelected(product)}
                                errorLabel={this.state.data.fieldProductErrorMessage}
                                isError={this.state.isError && this.state.isProductSelectorError}
                                dataLayer={dataLayer}
                                imgUrl={imgUrl}
                            />
                            <JobSize
                                ref={(ref)=>this.myRefs.area = ref}
                                isImperialSystem={this.state.isImperialSystem}
                                title={this.state.data.fieldJszTitle}
                                paragraph={this.state.data.fieldJszDescription}
                                labelWidth={this.state.data.fieldJsWidthLabel}
                                descriptionWidth={this.state.data.fieldJsWidthFieldDescription}
                                labelHeight={this.state.data.fieldJsHeightFieldLabel}
                                descriptionHeight={this.state.data.fieldJsHeightFieldDesc}
                                labelArea={this.state.data.fieldJsAreaFieldLabel}
                                descriptionArea={this.state.data.fieldJsAreaFieldDesc}
                                onAreaEntered={(area)=>this.onAreaEntered(area)}
                                errorLabel={this.state.data.fieldJobSizeErrorMessage}
                                isError={this.state.isError && this.state.isAreaError}
                                imageMeterSquare={this.state.data.fieldJsFieldImage.entity.fieldMediaImage.entity.url}
                                imageFeetSquare={this.state.data.fieldJobSizeImageFeetsquare.entity.fieldMediaImage.entity.url}
                            />
                            <TilesSizes
                                ref={(ref)=>this.myRefs.tilesDimensions = ref}
                                isImperialSystem={this.state.isImperialSystem}
                                widthLabel={this.state.data.fieldTsWidthFieldLabe}
                                heightLabel={this.state.data.fieldTsHeightFieldTit}
                                widthDescription={this.state.data.fieldTsWidthFieldDesc}
                                heightDescription={this.state.data.fieldTsHeightFieldDesc}
                                floorLabel={this.state.data.fieldTsFloorPartField}
                                floorDescription={this.state.data.fieldTsFloorPartFieldDesc}
                                floorOperator={this.state.data.fieldTsOperator}
                                addTileSizeButtonLabel={this.state.data.fieldTsAddAnotherButton}
                                inactiveButtonLabel={this.state.data.fieldTsAddAnotherButton}
                                title={this.state.data.fieldTsZoneTitle}
                                paragraph={this.state.data.fieldTsZoneDescription}
                                rowTitle={this.state.data.fieldTsRowTitle}
                                onTilesDimensionsEntered={(tilesDimensions)=>this.onTilesDimensionsEntered(tilesDimensions)}
                                errorLabel={this.state.data.fieldTilesSizesErrorMessage}
                                floorPartErrorLabel={this.state.data.fieldFloorPartMatchError}
                                errorBtnLabel={this.state.data.fieldTileSizeLimitMessage}
                                isError={this.state.isError && this.state.isTilesDimensionsError}
                                isErrorFloorPart={this.state.isTilesDimensionsFloorPartError}
                                imageTile1={this.state.data.fieldTsFieldImage.entity.fieldMediaImage.entity.url}
                                imageTile2={this.state.data.fieldTileSizeFieldImageMult.entity.fieldMediaImage.entity.url}
                                dataLayer={dataLayer}
                                product={this.state.selectedProduct}
                                context={context}
                                imgUrl={imgUrl}
                            />
                            <GroutJointSize
                                ref={(ref)=>this.myRefs.jointDimensions = ref}
                                isImperialSystem={this.state.isImperialSystem}
                                title={this.state.data.fieldGjZoneTitle}
                                paragraph={this.state.data.fieldGjZoneDescription}
                                widthLabel={this.state.data.fieldGjWidthFieldLabel}
                                depthLabel={this.state.data.fieldGjHeightFieldLabel}
                                widthDescription={this.state.data.fieldGjWidthFieldDesc}
                                depthDescription={this.state.data.fieldGjHeightFieldDesc}
                                onJointDimensionsEntered={(jointDimensions)=>this.onJointDimensionsEntered(jointDimensions)}
                                errorLabel={this.state.data.fieldGroutJointErrorMessage}
                                isError={this.state.isError && this.state.isJointDimensionsError}
                                groutJointImage={this.state.data.fieldGjFieldImage.entity.fieldMediaImage.entity.url}
                            />
                            <Calculation
                                ref={(ref)=>this.myRefs.result = ref}
                                isImperialSystem={this.state.isImperialSystem}
                                unitSystem={this.state.data.fieldUnitSystem}
                                isReady={this.state.isReady}
                                showResult={this.state.showResult}
                                product={this.state.selectedProduct}
                                area={this.state.area}
                                tilesDimensions={this.state.tilesDimensions}
                                jointDimensions={this.state.jointDimensions}
                                onThrowError={()=>this.throwError()}
                                onShowResult={()=>this.onShowResult()}
                                linkTitle={this.state.data.fieldProductLinkTitle}
                                buttonLabel={this.state.data.fieldCalculateButtonLabel}
                                inactiveButtonLabel={this.state.data.fieldCalculationInactiveButto}
                                title={this.state.data.fieldResultsZoneTitle}
                                totalLabel={this.state.data.fieldTotalAmountTitle}
                                packagedLabel={this.state.data.fieldPackagedAmountTitle}
                                orLabel={this.state.data.fieldCalculationOrLabel}
                                printButtonLabel={this.state.data.fieldPrintButtonLabel}
                                findDistributorButtonLabel={this.state.data.fieldDistributorButtonLabel}
                                findDistributorLink={this.state.data.fieldDistributorLink ? this.state.data.fieldDistributorLink.uri : null}
                                legalParagraph={this.state.data.fieldDisclaimer}
                                ofLabel={this.state.data.fieldCalculationLabelOf}
                                printContainerRef={this.myRefs.printContainer}
                                dataLayer={dataLayer}
                                country={country}
                                imgUrl={imgUrl}
                                locale={locale}
                                BreakdownProductName={this.state.data.BreakdownProductName}
                                BreakdownRatio={this.state.data.BreakdownRatio}
                            />
                        </div>
                    </div>
                :
                    <Loader imgUrl={imgUrl} />
                }
            </div>
        );
    }
}

export default App;
